import {
  H2,
  H3,
  Paragraph,
  ScrollContainer,
  Section,
} from "../../Styles/Global.Styled";
import Ellipse1 from "../../assets/Images/Ellipse1.png";
import Ellipse5 from "../../assets/Images/Ellipse5.png";
import Ellipse7 from "../../assets/Images/Ellipse7.png";
import { css } from "styled-components";
import ClientsReview from "./ClientsReview";
import { useEffect, useRef } from "react";

const sectionStyle = css`
  padding: 5vh 0;
  gap: 2vh;
  align-items: center;
`;
const paraStyle2 = css`
  text-align: center;
  width: 40%;
`;
const scrollCntStyle = css`
  width: 100%;
  overflow-x: auto;
  padding: 5vh 30vw;
  gap: 5vw;
  align-items: center;
`;
const fontSize6 = css`
  font-size: 3vh;
`;
const widthStyle = css`
  width: 100%;
`;

const clientsReviewsSample = [
  {
    reviewText:
      "Their fresh, vibrant blooms elevate our events to enchanting experiences. Consistency, reliability, and a touch of elegance define our partnership. Clients are mesmerized, and our reputation soars with each petal.",
    name: "Emma Greenfield",
    starsCount: 5,
    jobTitle: "CEO of Blooms & Beyond Events",
    image: Ellipse7,
  },
  {
    reviewText:
      "The diverse and impeccable quality of flowers transforms our floral designs. From classic arrangements to avant-garde displays, Petals Perfection never disappoints. A floral haven for discerning clients.",
    name: "Liam Blossom",
    starsCount: "",
    jobTitle: "Owner of Petals Perfection Florals",
    image: Ellipse1,
  },
  {
    reviewText:
      "Their dedication to excellence crafts an enduring partnership. Impeccable designs, timely deliveries, and a range that suits every occasion. A trusted ally in creating unforgettable moments.",
    name: "Olivia Meadows",
    starsCount: 5,
    jobTitle: "Founder of Elegant Petal Productions",
    image: Ellipse7,
  },
  {
    reviewText:
      "Each order is a canvas awaiting artistic expression. The exquisite variety sparks creativity, ensuring our designs stand out. A floral dreamland for those who seek uniqueness.",
    name: "Noah Petalton",
    starsCount: 5,
    jobTitle: "Lead designer at Enchanting Blossom Designs",
    image: Ellipse5,
  },
  {
    reviewText:
      "From opulent weddings to corporate galas, their blooms define luxury. Majestic Floral Creations curates masterpieces that elevate our brand. A partnership that epitomizes sophistication.",
    name: "Adam Bloomington",
    starsCount: 5,
    jobTitle: "CEO of Majestic Floral Creations",
    image: Ellipse7,
  },
];

const Testimonials = () => {
  const parentRef = useRef(null);

  useEffect(() => {
    if (parentRef.current) {
      // Calculate the total width of all child elements
      const totalWidth = parentRef.current.scrollWidth;

      // Calculate the initial scroll position to center the items
      const centerScroll = (totalWidth - parentRef.current.clientWidth) / 2;

      // Set the initial scroll position
      parentRef.current.scrollLeft = centerScroll;
    }
  }, []);

  return (
    <Section id="testimonials" $baseStyle={sectionStyle}>
      <H3>Testimonials</H3>
      <H2 $baseStyle={fontSize6}>What Our Partners Say</H2>
      <Paragraph $baseStyle={paraStyle2} $mStyle={widthStyle}>
        Discover the inspiring stories of our satisfied customers, where joy
        blossoms and excellence knows no bounds.
      </Paragraph>
      <ScrollContainer ref={parentRef} $baseStyle={scrollCntStyle}>
        {clientsReviewsSample.map((item, index) => (
          <ClientsReview key={index} item={item} />
        ))}
      </ScrollContainer>
    </Section>
  );
};

export default Testimonials;
